import axios from '../axios'

var AlarmProvider = function () {
  return {
    async GetSensorsByRailobjectId (railobjectId) {
      return axios.get('/alarms/getsensors?railObjectId=' + railobjectId)
    }
  }
}
export default new AlarmProvider()



// WEBPACK FOOTER //
// ./src/providers/AlarmProvider.js